import { InterstitialWrap } from './Interstitial.style'
import { Maavaron } from '../../components/Ads'
import { useRouteChange } from '../../contexts'
import { useEffect, useState } from 'react'
import { useRootStore } from '../../store'

export const Interstitial = () => {
  const change = useRouteChange()
  const [load, setLoad] = useState<null | boolean>(null)
  const { setIsShowingMaavaron } = useRootStore()

  useEffect(() => {
    const oldPath = change
    if (oldPath.length > 1) {
      const isSeriesBefore =
        oldPath[oldPath.length - 2].match(/series\/(\d+)/gm)
      const isSeriesAfter = oldPath[oldPath.length - 1].match(/series\/(\d+)/gm)
      if (isSeriesBefore && isSeriesAfter) {
        setLoad(isSeriesBefore[0] !== isSeriesAfter[0])
      } else {
        setLoad(true)
      }
    } else {
      setLoad(true)
    }
  }, [change])

  useEffect(() => {
    setIsShowingMaavaron(!!load)
  }, [load, setIsShowingMaavaron])

  if (!load) {
    return null
  }
  return (
    <InterstitialWrap>
      <Maavaron key={'Interstitial'} theme={'ott'} />
    </InterstitialWrap>
  )
}
